import { Client } from '@microsoft/microsoft-graph-client';
import 'isomorphic-fetch';
import authService from './authService';

let cachedClient = null;
let cacheTimestamp = null;

/**
 * Retourne un client Microsoft Graph pré-authentifié.
 * Utilise le token Azure récupéré dynamiquement via authService.
 */
export const getGraphClient = async (forceRefresh = false) => {
  if (forceRefresh && cachedClient) {
    cachedClient = null;
    cacheTimestamp = null;
  }

  const CACHE_MAX_AGE = 50 * 60 * 1000;
  if (cachedClient && cacheTimestamp && (Date.now() - cacheTimestamp < CACHE_MAX_AGE)) {
    return cachedClient;
  }

  if (cachedClient && cacheTimestamp) {
    cachedClient = null;
    cacheTimestamp = null;
  }

  const authProvider = {
    getAccessToken: async () => {
      try {
        const token = await authService.getValidAzureToken();

        if (!token) {
          console.error('[GraphClient] ❌ Aucun token Azure disponible');
          throw new Error('Token Azure non disponible. Veuillez actualiser la page ou vous reconnecter à votre compte Microsoft.');
        }

        return token;
      } catch (error) {
        console.error('[GraphClient] ❌ Erreur récupération token:', error.message);

        if (error.message?.includes('Token') || error.message?.includes('compte')) {
          cachedClient = null;
          cacheTimestamp = null;
        }

        // Amélioration du message d'erreur pour guider l'utilisateur
        if (error.message?.includes('Aucun compte Azure connecté')) {
          throw new Error('Aucun compte Microsoft connecté. Veuillez vous déconnecter puis vous reconnecter avec votre compte Microsoft pour accéder à OneDrive.');
        } else if (error.message?.includes('Token Azure')) {
          throw new Error('Session Microsoft expirée. Veuillez actualiser la page ou vous reconnecter pour accéder à OneDrive.');
        } else {
          // Propager l'erreur originale avec un message plus clair
          throw new Error(`Impossible d'accéder à OneDrive : ${error.message}`);
        }
      }
    }
  };

  cachedClient = Client.initWithMiddleware({ authProvider });
  cacheTimestamp = Date.now();
  return cachedClient;
};

/**
 * Nettoie le cache du client Microsoft Graph.
 * CRITIQUE : Cette fonction doit être appelée lors de la déconnexion pour éviter
 * qu'un utilisateur B utilise les données du compte A.
 */
export const clearGraphClient = () => {
  if (cachedClient) {
    cachedClient = null;
    cacheTimestamp = null;
  }
};

export default getGraphClient;